// Firebase Installations registers in the background for Performance; when the
// network drops it rejects internally with no caller to catch it, and
// Performance falls back to its default config ("Could not fetch config, will
// use default configs"). The registration is retried on the next app start.
// Sentry appends the request host to fetch failures.
const INSTALLATIONS_NETWORK_ERROR = /^(Failed to fetch|Load failed)\b.*\bfirebaseinstallations\.googleapis\.com\b/

export function isInstallationsNetworkErrorMessage(message: string): boolean {
  return INSTALLATIONS_NETWORK_ERROR.test(message)
}
